import { jsx as _jsx } from "react/jsx-runtime";
import Eye from '@helsenorge/designsystem-react/components/Icons/Eye';
import SharingStatus from '@helsenorge/designsystem-react/components/SharingStatus';
import styles from './styles.module.scss';
const SharingStatusWrapper = (props) => (_jsx(SharingStatus, { icon: Eye, color: 'kiwi', className: styles['sharing-status-wrapper'], children: props.children }));
export default SharingStatusWrapper;
